import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts } from "../../Styles";
import { PrimaryPopover, CoreNavLink } from "..";
import { useAttentions } from "../_Components";
import { AttentionTypes, CreateAttentionStyles, NavLinkTypes } from "../../Definitions";
import { useAppSelector } from "../../Store";
import { Graph_QL, useSystem } from "../../Services";
import { Pages } from "../../Navigation/root";

interface AttentionPopover_Props {
  systemNo: number
}
/**
 * AttentionPopover
 * @param systemNo Identifier for the system, used to retrieve system details.
 * @param onGoToSystemClick Optional callback for "Go to system" button click.
 * @returns A popover
 */
export default function AttentionPopover({ systemNo }: AttentionPopover_Props) {
  const {t} = useTranslation();

  // const { lanLogs } = useAttentions({ systemId: systemNo })

  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;

  const {call: getSystemCall, data: systemsState} = useSystem(connection); 
  
  useEffect(() => {
    getSystemCall({fetchAmount: 50})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Lookup system data based on systemNo
  const { systemName, systemType, attentionType, toPath } = useMemo(() => {
    const systemTypeToPage: Record<number, Pages> = {
      1: Pages.freeda_lf,
      2: Pages.freeda_esf
    };
  
    const systemTypeToLabel: Record<number, string> = {
      1: "Freeda Location Feeder",
      2: "Freeda ESF Walk Through"
    };
    
    const systemData = systemsState[domain]?.data.find((system) => system.system_id === systemNo);
    const page = systemData ? systemTypeToPage[systemData.fk_system_types] : undefined;
    const type = systemData ? systemTypeToLabel[systemData.fk_system_types] : undefined;
  
    // Default attentionType
    let _attentionType = systemData?.system_attention_type ?? AttentionTypes.neutral;
  
    // if (lanLogs && lanLogs.length > 0) {
    //   const hasLevel0 = lanLogs.some(log => log.level === 0);
    //   const hasLevel1 = lanLogs.some(log => log.level === 1);
  
    //   if (hasLevel0) {
    //     _attentionType = AttentionTypes.alert;
    //   } else if (hasLevel1) {
    //     _attentionType = AttentionTypes.warning;
    //   }
    // }
  
    return {
      systemName: systemData?.name || "",
      systemType: type || "",
      attentionType: _attentionType,
      toPath: `/${page}/${systemData?.system_id}`
    };
  }, [systemsState, domain, systemNo]);

  const { textColor, attentionText, attentionColor } = useMemo(() => {
    var _Style = CreateAttentionStyles(t, attentionType)
    return _Style
  }, [t, attentionType]);
  
  return (
    <PrimaryPopover
      content=""
      popoverHeader={attentionText}
      overrides={{
        contentContainer: {
          height: "10px",
          width: "30px",
          backgroundColor: attentionColor,
          borderRadius: "10px",
          cursor: "pointer"
        },
        popoverBgColor: attentionColor as typeof colors[keyof typeof colors],
        popoverHeaderFontSize: { ...fonts.fontSize4 }
      }}
      
      popoverContent={
        <div style={{padding: "10px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
          <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{systemName}</p>
          <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyPrimary, marginTop: "5px"}}>{systemType}</p>
            { attentionType === AttentionTypes.alert || attentionType === AttentionTypes.warning
              ? <CoreNavLink
                  content={t("systemControls.general.goToSystem", { defaultValue: "go to system" })}
                  path={toPath}
                  navLinkType={NavLinkTypes.systemStatusNavLink}
                  overrides={{
                    baseButton: { backgroundColor: attentionColor, marginTop: "15px" },
                    hoverStyles: { backgroundColor: attentionColor },
                    contentStyles: { color: textColor } 
                  }}
                />
              : <></> 
            }
        </div>
      }
    />
  )
}